import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372d1916"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "integrations",
  id: "integrations"
}
const _hoisted_2 = { class: "integrations-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "integrations-content-title" }, "Успешные рекламные интеграции произведены для:", -1))
const _hoisted_4 = { class: "integrations-content-companies" }
const _hoisted_5 = ["src"]

import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertisingIntegrationsMobile',
  setup(__props) {

const data = reactive({
  companies: ['mts', 'stoloto', 'fonbet', 'lamoda', 'ligastavok', 'perfect-world', 'paribet', 'my-games-cloud', 'warface']
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.companies, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            class: _normalizeClass(["integrations-content-companies-company", `${item}`]),
            src: require(`@/assets/images/clients/${item}.webp`),
            alt: ""
          }, null, 10, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}
}

})